import React from "react";

import "./QuickLinks.scss";

export default function QuickLinks() {
  return (
    <div className="quick_link_container">
      <h3>Quick links</h3>
      <ul>
        <li>
          <img src="diamond-icon.png" alt="diamond" />
          <p className="quick_link">Treasures</p>
        </li>
        <li>
          <img src="note_icon.png" alt="diamond" />
          <p className="quick_link">Custom Module</p>
        </li>
        <li>
          <img src="bookmark-icon.png" alt="diamond" />
          <p className="quick_link">Bookmarks</p>
        </li>
        <li>
          <img src="tick-icon.png" alt="diamond" />
          <p className="quick_link">Past Year Ques</p>
        </li>
      </ul>
    </div>
  );
}
